(function () {
  const root = document.querySelector('[data-cart-trust]');
  if (!root) return;

  const warrantyToggle = root.querySelector('[data-cart-trust-warranty]');
  if (warrantyToggle) {
    warrantyToggle.addEventListener('change', async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            attributes: { warranty_5yr: warrantyToggle.checked ? 'yes' : '' },
          }),
        });
        document.dispatchEvent(new CustomEvent('cart:trust:warranty', { detail: { enabled: warrantyToggle.checked } }));
      } catch (e) {
        console.error('Cart warranty toggle failed', e);
      }
    });
  }

  document.addEventListener('cart:updated', () => {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const subtotal = cart.total_price / 100;
        const deliveryEl = root.querySelector('[data-cart-trust-delivery]');
        const noteEl = root.querySelector('[data-cart-trust-delivery-note]');
        if (deliveryEl) {
          if (subtotal >= 1500) {
            deliveryEl.textContent = 'FREE';
            if (noteEl) noteEl.textContent = 'White-glove delivery is included on this order.';
          } else if (subtotal >= 500) {
            deliveryEl.textContent = '25% of total';
            if (noteEl) noteEl.textContent = `Add another $${Math.ceil(1500 - subtotal)} to qualify for free delivery.`;
          } else {
            deliveryEl.textContent = '$45 flat (local)';
            if (noteEl) noteEl.textContent = 'Local-area delivery. Outside our area? Contact us before checkout.';
          }
        }
      })
      .catch(() => {});
  });
})();
